
import { Component, ViewChild, OnInit, RendererStyleFlags2, Inject, OnDestroy, AfterViewInit, Input } from '@angular/core';
// import {VentasService} from './ventas.service';
 import {PresupuestosService} from '../presupuestos/presupuestos.service';
 import {PagosService} from '../pagos/pagos.service';
 import {PagosrService} from '../pagos_r/pagos_r.service';
 import {VentasService} from '../ventas/ventas.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { Subject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { MatSelect, VERSION } from '@angular/material';
import {LoginService} from 'app/main/content/login/login.service';
import * as moment from 'moment';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
declare var jquery: any; declare var $: any;
interface Bank {
  id: string;
  name: string;
}
interface Bank2 {
  id: string;
  name: string;
}
interface Bank3 {
  id: string;
  name: string;
}
interface Pais {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'fuse-my-app',
  templateUrl: './anadirpagocomponent2.component.html',
  styleUrls: ['./anadirpagocomponent2.component.scss']
})

  export class Anadirpagocomponent2Component implements OnInit, OnDestroy, AfterViewInit {  
    armtest: any;
    username: any;
    proyectos: any;
    servicios: any;
    choosed: any;
    Clientes2: any ;
    selectedValue: any ;
    selectedValue2: any ;
    importe: any ;
    concepto: any ;
    fecha: any ;
    choosedcliente: any;
    clientename: any;
    triger: any;
    proyecto: any;
    clientedata: any;
    clientData: any;
    remitentes: any;
    remitente2: any;
    choosedProject: any;
    choosedService: any;
    choosedServiceID: any;
    paisctrl: any;
    paises: Pais[] = [
      {value: 'spain', viewValue: 'España'},
      {value: 'otro', viewValue: 'Resto del Mundo'},
     
    ];
    // @Input() sideBar: PagosrComponent; 
    
    public bankCtrl: FormControl = new FormControl();
    private clientes: any; 
      
      /** control for the MatSelect filter keyword */
    public bankFilterCtrl: FormControl = new FormControl();
  
    /** list of clientes */
  
    
    
    public filteredBanks: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);
    
    
    
    @ViewChild('singleSelect') singleSelect: MatSelect;
    




    public bankCtrl2: FormControl = new FormControl();
    public bankCtrl3: FormControl = new FormControl();

  public bankFilterCtrl2: FormControl = new FormControl();
  public bankFilterCtrl3: FormControl = new FormControl();

  public filteredBanks2: ReplaySubject<Bank2[]> = new ReplaySubject<Bank2[]>(1);
  public filteredBanks3: ReplaySubject<Bank3[]> = new ReplaySubject<Bank3[]>(1);

  
    /** Subject that emits when the component has been destroyed. */
    private _onDestroy = new Subject<void>();
    
  
    ngOnInit() {
      this.remitentes = [
        {id: 0, nombre: 'LFDI', value: 1},
        {id: 1, nombre: 'TIE', value: 2}
      ]
      this.choosedProject = []
      this.triger = 0;
      this.pagos_r.getClientes()
      .subscribe(res => {
  this.clientes = res.clientes2;
  console.log(this.clientes)
  this.bankCtrl.setValue(this.clientes[10]);
      
  
      // load the initial bank list
      this.filteredBanks.next(this.clientes.slice());
      this.bankFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });
      })
    
  
      // listen for search field value changes
  
      }
  
      getlistCliente(){
  
  
      };
      ngAfterViewInit() {
        this.setInitialValue();
        this.setInitialValue2();
        this.setInitialValue3();

      }
      
      ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
      }
      
      private setInitialValue() {
        this.filteredBanks
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            // setting the compareWith property to a comparison function
            // triggers initializing the selection according to the initial value of
            // the form control (i.e. _initializeSelection())
            // this needs to be done after the filteredBanks are loaded initially
            // and after the mat-option elements are available
            this.singleSelect.compareWith = (a: Bank, b: Bank) => a.id === b.id;
           
          });
      }
      private filterBanks() {
        if (!this.clientes) {
          return;
        }
        // get the search keyword
        let search = this.bankFilterCtrl.value;
        if (!search) {
          this.filteredBanks.next(this.clientes.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        // filter the clientes
        this.filteredBanks.next(
          this.clientes.filter(clientes => clientes.nombre.toLowerCase().indexOf(search) > -1)
        );
      }

    
      private setInitialValue2() {
        this.filteredBanks2
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            // setting the compareWith property to a comparison function
            // triggers initializing the selection according to the initial value of
            // the form control (i.e. _initializeSelection())
            // this needs to be done after the filteredBanks are loaded initially
            // and after the mat-option elements are available
            this.singleSelect.compareWith = (a: Bank2, b: Bank2) => a.id === b.id;
           
          });
      }
      private setInitialValue3() {
        this.filteredBanks3
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            // setting the compareWith property to a comparison function
            // triggers initializing the selection according to the initial value of
            // the form control (i.e. _initializeSelection())
            // this needs to be done after the filteredBanks are loaded initially
            // and after the mat-option elements are available
            this.singleSelect.compareWith = (a: Bank3, b: Bank3) => a.id === b.id;
           
          });
      }
      private filterBanks2() {
        if (!this.servicios) {
          return;
        }
        // get the search keyword
        let search = this.bankFilterCtrl2.value;
        if (!search) {
          this.filteredBanks2.next(this.servicios.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        // filter the clientes
        this.filteredBanks2.next(
          this.servicios.filter(servicios => servicios.nombre.toLowerCase().indexOf(search) > -1)
        );
      }
      private filterBanks3() {
        if (!this.servicios) {
          return;
        }
        // get the search keyword
        let search = this.bankFilterCtrl3.value;
        if (!search) {
          this.filteredBanks3.next(this.servicios.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        // filter the clientes
        this.filteredBanks3.next(
          this.servicios.filter(servicios => servicios.nombre.toLowerCase().indexOf(search) > -1)
        );
      }
  
    /* constructor(@Inject(MAT_DIALOG_DATA) public data: any) { */
      constructor(public dialogRef: MatDialogRef<Anadirpagocomponent2Component>, private presupuestos: PresupuestosService, private pagos_r: PagosrService, private pagos: PagosService, private ventas: VentasService) {
        
      }
      
      saveData(bankCtrl){
/*         if (bankCtrl.value.CIF === undefined || bankCtrl.value.CIF === "undefined"){
          alert("Faltan datos de CIF");
          this.triger = 1;
        }
        else if (bankCtrl.value.email === undefined || bankCtrl.value.email === "undefined"){
  
          alert("Faltan datos de email");
          this.triger = 1;
        }
        else if (bankCtrl.value.direccion === undefined || bankCtrl.value.direccion === "undefined"){
  
          alert("Faltan datos de direccion");
          this.triger = 1;
        }
        else if (bankCtrl.value.codigo_postal === undefined || bankCtrl.value.codigo_postal === "undefined"){
  
          alert("Faltan datos de codigo postal");
          this.triger = 1;
        }
        else if (bankCtrl.value.ciudad === undefined || bankCtrl.value.ciudad === "undefined"){
  
          alert("Faltan datos de ciudad");
          this.triger = 1;
        } 
  else{*/
    this.triger = 0;
        console.log(bankCtrl.value);
        this.clientData = bankCtrl.value;
        this.clientename = bankCtrl.value.nombre;
        this.choosedcliente = bankCtrl.value.id;
          this.clientedata = bankCtrl.value;
        // this.dialogRef.close({id_cliente: bankCtrl.value.id, nombre: bankCtrl.value.nombre});

        this.presupuestos.getServiciosbypresup(this.clientename.replace(/[^a-zA-Z ñ í é ú á ü ó Á É Í Ó Ú Ñ Ü]/g, ""))
        .subscribe(res => {
          console.log(res)
    this.servicios = res.presupuestos3;
    console.log(this.servicios)
    // this.servicios.push({id: 3, nombre: "Elegir servicio", plazo: 0, precio: 0});
    console.log(this.servicios[0])
    this.bankCtrl2.setValue(this.servicios[0]);
    this.bankCtrl3.setValue(this.servicios[0]);

this.choosedService = this.servicios[0].servicio
this.choosedServiceID = this.servicios[0].id_servicio   
this.choosed = this.servicios[0].numero
    
        this.filteredBanks2.next(this.servicios.slice());
        this.bankFilterCtrl2.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBanks2();

        });

        this.filteredBanks3.next(this.servicios.slice());
        this.bankFilterCtrl3.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBanks3();

        });


        })



/*         this.pagos_r.getProyectosForR(bankCtrl.value.id)
        .subscribe(res => {
          
    this.proyectos = res.proyectos;
    console.log(this.proyectos)
  
        }) */
      }


      saveData1(bankCtrl2){


        console.log(bankCtrl2.value);
this.proyecto = bankCtrl2.value.servicio
this.choosed = bankCtrl2.value
 this.bankCtrl3.setValue(bankCtrl2.value);
 this.filteredBanks3.next(bankCtrl2.value);
 this.bankFilterCtrl3.valueChanges
 .pipe(takeUntil(this._onDestroy))
 .subscribe(() => {
   this.filterBanks3();

 });

 this.choosedService = bankCtrl2.value.servicio
this.choosedServiceID = bankCtrl2.value.id_servicio   
console.log(this.choosedService)
console.log(this.choosedServiceID)




      }
      /*   } */
        saveData2(value){

/*           this.pagos_r.getServicios(value.id)
          .subscribe(res => {
      this.servicios = res.servicios;
      console.log(this.servicios)
    
          })
  
          console.log(value); */
        }
  


        verpresu(){
  
            window.open("http://lfdi.bitronedev.com/public/" + this.choosed.numero + ".pdf", "_blank");

        }
       
  
        saveDataTotal(fecha, concepto, importe, selectedValue2, selectedValue, paisctrl, remitente2){
          console.log(this.choosedcliente);
          console.log(fecha);
          console.log(importe);
          console.log(concepto);
          console.log(this.proyecto);
     
/*           if (this.choosedcliente === undefined ||  fecha === undefined  || concepto === undefined || importe === undefined ){
  alert("rellene todos los campos")
          }
  
  
          else{ */
  var datefecha = new Date(fecha._d); 
  var datefecha2 = datefecha.toLocaleString();
          console.log(datefecha2);
          console.log(concepto);
          console.log(importe);
          console.log(selectedValue2);
          console.log(selectedValue);
          console.log(this.clientedata);
          console.log(this.choosedcliente);
var totalapagar = 0

          this.pagos.addPagos(this.clientename, this.proyecto, this.choosedServiceID,  totalapagar, importe, datefecha2)
          .subscribe(res => {
            console.log(res);
            this.ventas.createInvoice(this.clientename, this.clientData.CIF, fecha, this.choosed.proyecto, this.clientData.telefono, this.clientData.email, this.clientData.direccion, this.clientData.codigo_postal, this.clientData.ciudad, this.clientData.empresa, concepto,   this.choosedServiceID, this.choosedService, importe, paisctrl, remitente2.id).subscribe(res4 => {
              console.log(res4);
            })


   /*        this.pagos_r.addPagos(this.choosedcliente, datefecha2, concepto, importe, selectedValue2.id, selectedValue.id)
        .subscribe(res => {
          console.log(res); */
  
  
  
          if (res.response.status ){
 /*            this.pagos_r.sendEmail(this.clientedata, datefecha2, concepto, importe, selectedValue2.nombre, selectedValue.nombre)
            .subscribe(res2 => {
              console.log(res2);
              var fullDate = datefecha;
              var twoDigitMonth = fullDate.getMonth() + "";
              if (twoDigitMonth.length === 1){
                  twoDigitMonth = "0" + twoDigitMonth;
              }
              var twoDigitDate = fullDate.getDate() + "";
              if (twoDigitDate.length === 1){
                  twoDigitDate = "0" + twoDigitDate;
              }
              
              
              
              var currentDate = fullDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate; console.log(currentDate);
              this.dialogRef.close({cliente: this.clientename, proyecto: selectedValue.nombre, servicio: selectedValue2.nombre, importe: importe, concepto: concepto, fecha: currentDate });
            }) */
            var fullDate = datefecha;
            var twoDigitMonth = fullDate.getMonth() + "";
            if (twoDigitMonth.length === 1){
                twoDigitMonth = "0" + twoDigitMonth;
            }
            var twoDigitDate = fullDate.getDate() + "";
            if (twoDigitDate.length === 1){
                twoDigitDate = "0" + twoDigitDate;
            }
            var currentDate = fullDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate; console.log(currentDate);
            this.dialogRef.close({cliente: this.clientename, proyecto: this.proyecto, servicio: this.choosed.servicio, importe: importe, concepto: concepto, fecha: currentDate });
          }
  
        })
      //  }
      }
  
  }


